import Highcharts, { defaultOptions } from 'highcharts/highstock'

import HCMore from 'highcharts/highcharts-more'
import HighchartsReact from 'highcharts-react-official'
import { ProjectType } from '../../enum/ProjectType.enum'
import React from 'react'
import { useStoreContext } from '../../store/StoreContext'

HCMore(Highcharts)

const StockChart: React.FC<{
  data: any
  startDate: any
  single?: boolean
  value?: any
  marker?: boolean
  width?: any
}> = ({
  data,
  startDate,
  single,
  value,
  marker = true,
  width = window.innerWidth >= 1580 ? 600 : 400
}) => {
  const store = useStoreContext()
  const projectType = store.scopeStore.getSelectedProject().type
  const isFullStackProject = projectType === ProjectType.FULL_STACK_ONLY

  const now = new Date().getTime()
  const yearAgo = now - 32 * 24 * 60 * 60 * 1000

  const dataTimestamps = data.map((point: any) => point[0])
  const minTimestamp = Math.min(...dataTimestamps)
  const maxTimestamp = Math.max(...dataTimestamps)

  const xAxisMin = Math.max(yearAgo, minTimestamp)
  const xAxisMax = maxTimestamp

  const options = {
    rangeSelector: {
      enabled: false
    },
    navigator: {
      enabled: false
    },
    chart: {
      zoomType: 'x',
      height: 200,
      width: width
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    scrollbar: {
      enabled: false
    },
    tooltip: {
      formatter: function (): any {
        const formattedDate = Highcharts.dateFormat('%Y-%m-%d', (this as any).x)
        return (
          'Date: ' +
          formattedDate +
          '<br/>' +
          (isFullStackProject ? 'Exception count: ' : 'Error count: ') +
          (this as any).y
        )
      }
    },
    plotOptions: {
      series: {
        marker: {
          enabled: marker, // Enable markers for data points
          symbol: 'circle', // Set marker symbol shape (e.g., circle, square, diamond)
          radius: 4, // Set marker size
          fillColor: 'rgb(6,108,255)', // Set marker fill color
          lineColor: '#ffffff', // Set marker border color
          lineWidth: 2 // Set marker border width
        }
      }
    },
    yAxis: {
      title: {
        text: null
      }
    },
    xAxis: {
      type: 'datetime',
      min: xAxisMin,
      max: xAxisMax,
      labels: {
        rotation: -90,
        formatter: function (): any {
          return Highcharts.dateFormat('%Y-%m-%d', (this as any).value)
        }
      }
    },
    series: [
      {
        data: data,
        name: '',
        showInLegend: false
      }
    ]
  }

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default StockChart
